export const MAP_COLORS = [
  '#0696A6',
  '#DBE9ED',
  '#D3D8D9',
  '#31494B',
  '#006176',
  '#77B0BE',
  '#6F7F81',
];

export const MARKER_SIZE = {
  min: 10,
  max: 25,
};

export const ZOOM_PADDING = 50;
export const MAX_ZOOM_LEVEL = 8;
export const ZOOM_FACTOR = 4;

export const getExtremesFromPoints = (
  arr: { x: number; y: number }[]
): { minX: number; minY: number; maxX: number; maxY: number } => {
  if (arr.length === 0) {
    return { minX: 0, minY: 0, maxX: 0, maxY: 0 };
  }

  return arr.reduce((acc: any, current: any) => {
    acc.minX = isNaN(acc.minX) ? current.x : Math.min(acc.minX, current.x);
    acc.maxX = isNaN(acc.maxX) ? current.x : Math.max(acc.maxX, current.x);
    acc.minY = isNaN(acc.minY) ? current.y : Math.min(acc.minY, current.y);
    acc.maxY = isNaN(acc.maxY) ? current.y : Math.max(acc.maxY, current.y);

    return acc;
  }, {});
};
